:host {
	grid-column: 1 / -1;
}
